import styled from "styled-components";

export const InitialSetupContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 24px;
  padding-right: 8px;
  overflow-y: scroll;

  ::-webkit-scrollbar-thumb {
    background-color: ${(props) => props.theme.colors.disabledMeatballItem};
    border-radius: 10px;
  }
`;

export const ImageUploadSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const ImageUploadWrapper = styled.div`
  position: relative;
  width: 100%;
  height: 158px;
  padding: 16px;
  gap: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${(props) => props.hasError ? props.theme.colors.statusError : props.theme.colors.disabledMeatballItem};
  border-radius: 5px;
`;

export const RenderedImage = styled.img`
  display: block;
  width: 113px;
  height: 126px;
  border-radius: 2px;
  object-fit: contain;
`;

export const ImageInputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 250px;
  gap: 8px;

  .image-upload-button {
    height: 32px;
    width: 158px;
    padding: 8px 24px;
    margin-top: 8px;
    border-radius: 5px;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
    text-transform: none;
  }
`;

export const BtnWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 16px;

    .uploaded-btn {
      height: 32px;
      width: 85px;
      padding: 6px 18px;
      margin-top: 8px;
      border-radius: 5px;
      font-size: 14px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      text-transform: none;
    }

    .clear-btn {
      border: 1px solid ${(props) => props.theme.colors.avataBorderColor};
    }
`;

export const Title = styled.h2`
  color: ${(props) => props.theme.colors.constrat};
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`;

export const InputWrapper = styled.span`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
  gap: 8px;

  /* Remove as setinhas do input number */
  input[type="number"]::-webkit-outer-spin-button,
  input[type="number"]::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  input[type="number"] {
    -moz-appearance: textfield; /* Para Firefox */
  }
`;

export const Label = styled.span`
  color: ${(props) => props.theme.colors.constrat};
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
`;

export const Input = styled.input`
  color: ${(props) => props.theme.colors.constrat};
  width: 100%;
  min-height: 30px;
  padding: 8px;
  border-radius: 5px;
  background: ${(props) => props.theme.colors.disabledMeatballItem};
  border: 1px solid transparent;

  &::placeholder {
    color: ${(props) => props.theme.colors.placeholder};
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  &:focus {
    box-shadow: none;
  }
`;

export const TextArea = styled.textarea`
  color: ${(props) => props.theme.colors.constrat};
  width: 100%;
  min-height: 72px;
  padding: 8px;
  border-radius: 5px;
  background: ${(props) => props.theme.colors.disabledMeatballItem};
  border: none;
  resize: none;
  overflow-y: auto;

  &::placeholder {
    color: ${(props) => props.theme.colors.placeholder};
    font-family: Roboto;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  &:focus {
    box-shadow: none;
  }
`;

export const SampleWrapper = styled.div`
  display: flex;
  gap: 16px;
`;

export const SmallInputWrapper = styled(InputWrapper)`
  width: 100px;
  position: relative;
`;

export const MediumInputWrapper = styled(InputWrapper)`
  width: 219px;
`;

export const InputTitle = styled(Input)`
  border-color: ${(props) => props.warning ? props.theme.colors.warningMessage : 'transparent'};
`;

export const PercentInput = styled(Input)`
  padding: 8px 16px 8px 8px;
  border-color: ${(props) => props.warning ? props.theme.colors.warningMessage : 'transparent'};
`;

export const Symbol = styled.span`
  color: ${(props) => props.theme.colors.constrat};
  font-family: Roboto;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  position: absolute;
  right: 5px;
  bottom: 8px;
`;

export const Counter = styled.span`
  color: ${(props) => props.theme.colors.constrat};
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  position: absolute;
  right: 0;
  bottom: -18px;
`;

export const WarningMessage = styled.span`
  color: ${(props) => props.theme.colors.warningMessage};
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  position: absolute;
  bottom: -18px;
`;


export const ReportErrorMessage = styled.span`
  color: ${(props) => props.theme.colors.statusError};
  font-family: Roboto;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  position: absolute;
  padding-left: 0;
  margin-top: 0;
  bottom: -18px;
  left: 0px;
`;
